import { Component } from 'react';
import CustomizedTextField from '../../Input/CustomizedTextField';
import { getCurrentFunctionName } from '../../../performanceModeManager';
import { Dialog, DialogContent } from '@mui/material';
import TextFieldWithSuggestions from '../../Input/TextFieldWithSuggestions';
import { withStyles } from '@mui/styles';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import { Typography } from '@mui/material';
import ValidateIcon from '@mui/icons-material/Check';

const styles = {
    appBar: {
        position: 'relative',
        marginBottom: '10px',
    },
    flex: {
        flex: 1,
    },
};

class InterventionTextWithSuggestionsField extends Component {

    constructor(props) {
        super(props);

        let defaultValue = this.props.value.value_text;

        this.state = {
            value: defaultValue,
            modalOpenned: false,
            suggestions: this.generateSuggestions()
        }
    }

    static getDerivedStateFromProps(props, state) {

        if (state.typedJustNow)
            return state;

        state.value = props.value.value_text;
        return state;
    }

    generateSuggestions() {
        return this.props.model.value_text_ids.map((suggestion) => {
            return {
                name: suggestion.name,
                value: suggestion.text_value
            }
        })
    }

    openModal() {
        if (!this.props.inputProperties.disabled && !this.state.modalOpenned)
            this.setState({
                modalOpenned: true,
            })
    }

    closeModal() {
        this.setState({ modalOpenned: false })
    }

    handleChange(value) {
        let fieldValue = this.props.value;
        fieldValue.value_text = value;

        this.props.fieldValueChange(fieldValue);
    }

    render() {
        const { classes } = this.props;
        console.perfLog(getCurrentFunctionName());
        return (
            <div>
                <Dialog open={this.state.modalOpenned} onClose={this.closeModal.bind(this)} fullScreen aria-labelledby="form-dialog-title">
                    <AppBar className={classes.appBar}>
                        <Toolbar>
                            <Typography variant="h6" color="inherit" className={classes.flex}>
                                {this.props.model.name}
                            </Typography>
                            <IconButton color="inherit" onClick={this.closeModal.bind(this)} aria-label="Validate">
                                <ValidateIcon />
                            </IconButton>
                        </Toolbar>
                    </AppBar>
                    <Toolbar/>
                    <DialogContent className="without-side-padding">
                        <TextFieldWithSuggestions onValueChange={this.handleChange.bind(this)}
                            value={this.state.value} multiline={this.props.multiline} suggestions={this.state.suggestions} />
                    </DialogContent>
                </Dialog>
                <CustomizedTextField onMouseDown={this.openModal.bind(this)}
                    label={this.props.model.name} {...this.props.inputProperties} value={this.state.value}
                    className={this.props.inputProperties.className + " full_size control-margin-top"}
                    multiline={this.props.multiline} inputProps={{ onClick: this.openModal.bind(this) }} />
            </div>
        )
    }
}

export default withStyles(styles)(InterventionTextWithSuggestionsField);
